import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useEffect, useState } from 'react'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

export const useContactCodesStatus = (cid: string) => {
  const [codes, setCodes] = useState<{ [type: string]: string }>()

  const getContactCodes = async () => {
    const crud = CrudStore.get(CrudStoreItem.ContactCodeRequests, `getContactCodes-${cid}`)
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'ContactId',
          operator: Operator.EQUAL,
          value: cid,
        },
        {
          field: 'Status',
          operator: Operator.NOTEQUAL,
          value: 'Done',
        },
      ],
    })
    crud.setPaging({ page: 0, pageSize: 10 })
    crud.setSort({ field: 'EntryId', dir: 'desc' })
    const result = await crud.fetch()
    if (result.items.length) {
      const newData = {}
      result.items.forEach((el) => {
        if (!newData[el.Type]) {
          newData[el.Type] = el.Status
        }
      })
      setCodes(newData)
    }
  }

  useEffect(() => {
    setCodes(undefined)
    cid && getContactCodes()
  }, [cid])

  return codes
}
